import type { Project } from '../../aansluiting/project/types/Project'
import { request } from '../../gateways/api'
import type { HoofdleidingProject } from '../../hoofdleiding/project/types/HoofdleidingProject'

export { fetchSearchBar }

const fetchSearchBar = async ({
  id,
}: {
  id: string
}): Promise<(Project | HoofdleidingProject)[]> => {
  const result = await request({
    url: `/rest/project/search-bar`,
    method: 'POST',
    data: {
      text: id,
    },
  })

  return result
}
